import type { TitleProps } from './types.js'
import { cn } from '../../helpers/utils.js'
import { Picture, Text } from '../../components/index.js'

const CpnTitle = (props: TitleProps) => {
  const { html, icon_l, icon_r, cns } = props

  return (
    <div className={cn('cpn-title-container flex items-start justify-center gap-5 text-center', cns?.container)}>
      {icon_l && <Picture source={icon_l} alt={''} className={cn('cpn-title-icon-l', cns?.icon_l)} />}
      <Text html={html} className="cpn-title-text laptop:text-[40px] text-[24px] font-bold" />
      {icon_r && <Picture source={icon_r} alt={''} className={cn('cpn-title-icon-r', cns?.icon_r)} />}
    </div>
  )
}

export default CpnTitle
